<template>
  <tr>
    <td>{{ question.question }} </td>
    <td>
      <input
        :id="generateUuid()"
        v-model="value"
        type="radio"
        :name="question.question"
        value="1"
        @click="question.value = 1"
      >
    </td>
    <td>
      <input
        :id="generateUuid()"
        v-model="value"
        type="radio"
        :name="question.question"
        value="2"
        @click="question.value = 2"
      >
    </td>
    <td>
      <input
        :id="generateUuid()"
        v-model="value"
        type="radio"
        :name="question.question"
        value="3"
        @click="question.value = 3"
      >
    </td>
    <td>
      <input
        :id="generateUuid()"
        v-model="value"
        type="radio"
        :name="question.question"
        value="4"
        @click="question.value = 4"
      >
    </td>
    <td>
      <input
        :id="generateUuid()"
        v-model="value"
        type="radio"
        :name="question.question"
        value="5"
        @click="question.value = 5"
      >
    </td>
  </tr>
</template>

<script>
import uuid from 'uuid/v4';

export default {
  name: "SurveyQuestion",
  props: { question: {type: Object, required: true}},
  data(){
    return {
      value: null
    }
  },
  mounted() {
  
  },
  methods:{
    generateUuid(){
    return uuid()
    },
  }
};
</script>
